import { useSetRecoilState } from "recoil";
import { userManagementSearchAtom } from "../miscellaneous/userManagementSearchAtom";

export const useSetUserManagementSearch = () => {
  return useSetRecoilState(userManagementSearchAtom);
};
